// extracted by css-extract-rspack-plugin
export default {"root":"root-ikUwts","header":"header-g3aIqZ","excerpt":"excerpt-HU86L5","meta":"meta-xdO7DN","postLink":"postLink-xu8rO7"};